import { createMuiTheme } from '@material-ui/core/styles'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#032587',
      background: '#FED388',
      contrastText: '#fff'
    },
    error: {
      main: '#eb0000',
      contrastText: '#fff'
    }
  },
  typography: {
    useNextVariants: true
  }
})

export default theme
